import ParagraphModal from "./ParagraphModal";

const ParagraphButton = ({
  paragraphModelOpen,
  setParagraphModalOpen,
  paragraph,
}) => {
  return (
    <>
      <button
        style={{
          position: "fixed",
          top: "85px",
          right: "60px",
          padding: "10px 32.5px",
          fontSize: "18px",
          borderRadius: "5px",
          backgroundColor: "#2D2D2D", // 바 색상
          color: "#FFF",
          border: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={() => setParagraphModalOpen(!paragraphModelOpen)}
      >
        본문 보기
      </button>
      {paragraphModelOpen && (
        <ParagraphModal
          paragraph={paragraph}
          setParagraphModalOpen={setParagraphModalOpen}
        />
      )}
    </>
  );
};

export default ParagraphButton;
